var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "#40599B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8222 22.5539C27.9109 22.465 28.0162 22.3944 28.1322 22.3463C28.2482 22.2982 28.3725 22.2734 28.4981 22.2734C28.6236 22.2734 28.7479 22.2982 28.8639 22.3463C28.9799 22.3944 29.0852 22.465 29.1739 22.5539L32.9921 26.3721C33.0808 26.4608 33.1512 26.5662 33.1992 26.6821C33.2473 26.7981 33.272 26.9224 33.272 27.0479C33.272 27.1734 33.2473 27.2977 33.1992 27.4136C33.1512 27.5296 33.0808 27.6349 32.9921 27.7237C32.9033 27.8124 32.7979 27.8828 32.682 27.9309C32.566 27.9789 32.4417 28.0036 32.3162 28.0036C32.1907 28.0036 32.0664 27.9789 31.9505 27.9309C31.8345 27.8828 31.7292 27.8124 31.6404 27.7237L29.4526 25.534V32.7751C29.4526 33.0283 29.352 33.2711 29.173 33.4501C28.994 33.6291 28.7512 33.7297 28.4981 33.7297C28.2449 33.7297 28.0021 33.6291 27.8231 33.4501C27.6441 33.2711 27.5435 33.0283 27.5435 32.7751V25.534L25.3557 27.7237C25.1765 27.9029 24.9334 28.0036 24.6799 28.0036C24.4264 28.0036 24.1833 27.9029 24.0041 27.7237C23.8248 27.5445 23.7241 27.3014 23.7241 27.0479C23.7241 26.7944 23.8248 26.5513 24.0041 26.3721L27.8222 22.5539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.64 19.105C23.5481 17.4596 25.9817 16.5509 28.5012 16.543C33.6367 16.543 37.8997 20.3612 38.3636 25.2847C41.4029 25.7142 43.774 28.2591 43.774 31.3823C43.774 34.8111 40.9142 37.543 37.4492 37.543H20.4468C16.4892 37.543 13.2285 34.4235 13.2285 30.5137C13.2285 27.148 15.6454 24.3607 18.8451 23.6543C19.1181 22.0068 20.1776 20.365 21.64 19.105ZM22.8866 20.5502C21.4414 21.7968 20.6854 23.2992 20.6854 24.4752V25.3305L19.8359 25.4241C17.1689 25.7162 15.1376 27.9059 15.1376 30.5137C15.1376 33.3143 17.4858 35.6339 20.4468 35.6339H37.4492C39.9176 35.6339 41.8649 33.7019 41.8649 31.3823C41.8649 29.0609 39.9176 27.1289 37.4492 27.1289H36.4946V26.1743C36.4965 21.9362 32.9456 18.4521 28.5012 18.4521C26.4392 18.4603 24.4479 19.2032 22.8866 20.5502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5455,
    height: 30.5455,
    fill: "white",
    transform: "translate(13.2285 12.7266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.d0d68aac378af014cf99ad5b3f040c4c.svg";
export { ForwardRef as ReactComponent };